import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class StepIndicator extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene
     */
    constructor(scene)
    {
        super(scene);

        let bgShape = this.scene.add.rectangle(0, 0, this.scene.scale.width, 60, 0xffffff).setOrigin(0);
        this.add(bgShape);

        let stepTxts = ["1."+ABCyaPhaser.Localization.instance.getLocalizedString("letter.heading"), "2."+ABCyaPhaser.Localization.instance.getLocalizedString("letter.salutation"), "3."+ABCyaPhaser.Localization.instance.getLocalizedString("letter.body"), "4."+ABCyaPhaser.Localization.instance.getLocalizedString("letter.closing"), "5."+ABCyaPhaser.Localization.instance.getLocalizedString("letter.signature")];

        this.totalMenuItemWidth = 0;
        this.steps = this.createAllSteps(stepTxts, []);
        //position after created to get even spacing
        let itemSpacing = (this.scene.scale.width - this.totalMenuItemWidth) / (this.steps.length + 1);
        for (let i = 0; i < this.steps.length; i++)
        {
            let s = this.steps[i];
            s.x = (i == 0) ? itemSpacing : this.steps[i - 1].x + this.steps[i - 1].stepWidth + itemSpacing;
            s.y = 12;
        }

        this.lineShape = this.scene.add.graphics();
        this.add(this.lineShape);
    }

    createAllSteps(arr, finalArr)
    {
        finalArr = finalArr || [];
        //create step text
        let step = this.createStep(arr[0]);
        this.add(step);
        step.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleStepClick(step));
        this.totalMenuItemWidth += step.stepWidth;
        finalArr.push(step);
        let remainingArr = arr.slice(1);
        if (remainingArr.length == 0)
        {
            return finalArr;
        }
        else
        {
            return this.createAllSteps(remainingArr, finalArr);
        }
    }

    createStep(str)
    {
        let stepClip = this.scene.add.container();
        let stepTxt = ABCyaPhaser.Text.addText(0, 0, 38, 0x877d73, FontKeys._cardenio_modernregular, str, stepClip, false).setOrigin(0);
        stepClip.txt = stepTxt;
        stepClip.stepWidth = stepTxt.width;
        stepClip.stepHeight = stepTxt.height;
        ABCyaPhaser.Container.setContainerInteractive(stepClip);
        return stepClip;
    }

    handleStepClick(sender)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this.scene);
        this.emit("BTN_SELECT", this.steps.indexOf(sender));
    }

    setSelectedStep(stepIndex)
    {
        let i = 0;
        let len = this.steps.length;
        while (i < len)
        {
            let step = this.steps[i];
            this.showStep(step, (i == stepIndex));
            i++;
        }

        this.lineShape.clear().lineStyle(3, 0xf7911d).lineBetween(this.steps[stepIndex].x, 50, this.steps[stepIndex].x + this.steps[stepIndex].width, 50);
    }

    showStep(step, isActive)
    {
        step.txt.setColor((isActive == true) ? "#F7911D" : "#877D73");
    }
}